import { useCallback, useEffect, useState } from 'react';
import { PollTypes, UnpublishedPollItem } from '../../../../db/polls/types';
import { ClassListItem } from '../../../../db/classes/types';
import { getUnpublishedPolls } from '../../../../db/polls';
import { CourseListItem } from '../../../../db/courses/types';
import { useAppContext } from '../../../../app/Context';
import Logger from '../../../../utils/logger';

export interface UnpublishedPoll extends UnpublishedPollItem {
  pollType: PollTypes.UNPUBLISHED;
}

export interface UseUnpublishedPolls {
  selectedCourse: CourseListItem;
  selectedClass: ClassListItem;
}

const useUnpublishedPolls = ({ selectedCourse, selectedClass }: UseUnpublishedPolls) => {
  const { setError } = useAppContext();

  const [isFetchingUnpublishedPolls, setIsFetchingUnpublishedPolls] = useState(true);
  const [unpublishedPolls, setUnpublishedPolls] = useState<UnpublishedPoll[]>([]);

  const fetchUnpublishedPolls = useCallback(async () => {
    setIsFetchingUnpublishedPolls(true);
    try {
      if (selectedClass.numActivities.polls === 0) return;

      const { unpublishedPolls } = await getUnpublishedPolls({
        courseId: selectedCourse.courseId,
        classId: selectedClass.classId,
      });

      const transformedUnpublishedPolls: UnpublishedPoll[] = unpublishedPolls.map((unpublishedPoll) => ({
        ...unpublishedPoll,
        pollType: PollTypes.UNPUBLISHED,
      }));

      setUnpublishedPolls(transformedUnpublishedPolls);
    } catch (error: any) {
      setError(error.message);
      Logger.error(error);
    } finally {
      setIsFetchingUnpublishedPolls(false);
    }
  }, [selectedCourse.courseId, selectedClass.classId, selectedClass.numActivities.polls]);

  useEffect(() => {
    fetchUnpublishedPolls();
  }, [fetchUnpublishedPolls]);

  return { isFetchingUnpublishedPolls, unpublishedPolls };
};

export default useUnpublishedPolls;
